import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import FooterPage from '../FooterPage';
import { FOOTER_PATHS } from './footerRoutes';
import { renderFooterContent } from './footerContent';

function FooterPageView() {
    const { pathname } = useLocation();
    const title = FOOTER_PATHS[pathname];

    if (!title) {
        return <Navigate to="/" replace />;
    }

    return (
        <FooterPage title={title}>
            {renderFooterContent(pathname)}
        </FooterPage>
    );
}

export default FooterPageView;
